import axios from '../../plugins/axios';

export default {
    namespaced: true,

    state: {
        adsCampaign: {},
        usedPromocode: {},
    },
    mutations: {
        SET_PROMO(state, payload) {
            state.adsCampaign = payload;
        },
        SET_USED_PROMO(state, payload) {
            state.usedPromocode = payload;
        },
    },
    actions: {
        async getByRoute({ commit }, { routeName }) {
            const { data } = await axios.get(`/front/acampaigns/${ routeName }`);
            commit('SET_PROMO', data);
        },
        async getUsedPromocode({ commit }, { code }) {
            console.log(code, 'code');
            
            const { data } = await axios.get('/front/settings/promocode', { params: { code } });
            commit('SET_USED_PROMO', data);
        }
    },
}
